import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    uigBranchesFeatureKey,
    UigBranchesState,
    UIG_BRANCHES_OVERVIEW,
    UIG_BRANCH_CREATE_OR_UPDATE,
    UIG_BRANCH_DELETE,
    UIG_BRANCH_DETAILS,
    UIG_BRANCH_STORE_FEATURE_GROUP
} from './uig-branches.reducer';

export const selectUigBranchesState = createFeatureSelector<UigBranchesState>(
    uigBranchesFeatureKey
);

//******************************************************

export const selectUigBranchesOverview = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCHES_OVERVIEW].uigBranchesOverview
);

export const loadingUigBranchesOverview = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCHES_OVERVIEW].isLoading
);

export const errorUigBranchesOverview = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCHES_OVERVIEW].error
);

//******************************************************

export const selectUigBranchDetails = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCH_DETAILS].branchForm
);

export const loadingUigBranchDetails = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCH_DETAILS].isLoading
);

export const errorUigBranchDetails = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCH_DETAILS].error
);

//******************************************************

export const deleteBranchSuccess = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCH_DELETE].success
);

export const deleteBranchFailure = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCH_DELETE].error
);

//******************************************************

export const createOrUpdateBranchSuccess = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCH_CREATE_OR_UPDATE].success
);

export const createOrUpdateBranchFailure = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCH_CREATE_OR_UPDATE].error
);

//******************************************************

export const selectUigStoreFeatureGroups = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCH_STORE_FEATURE_GROUP].featureGroups
);

export const loadingUigStoreFeatureGroups = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCH_STORE_FEATURE_GROUP].isLoading
);

export const errorUigStoreFeatureGroups = createSelector(
    selectUigBranchesState,
    (state: UigBranchesState) =>
        state[UIG_BRANCH_STORE_FEATURE_GROUP].error
);
